import * as React from 'react';
import { SVGProps } from 'react';
const SvgEmail = ({
  width = 24,
  height = 24,
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="#000"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M22.0002 5H2L2.00126 20H22L22.0002 5ZM20.0005 6.88895V7.44353L12.0004 13.5554L4.00046 7.44353V6.88797L20.0005 6.88895ZM3.99846 17.999L4.00046 9.42087L11.9994 15.533L20.0005 9.42185L20.0005 18L3.99846 17.999Z"
      fill="current"
    />
  </svg>
);
export default SvgEmail;
